export const APP_NAME = "Nexus Edge";
export const APP_MARK = "N";
